export const OPTIONS_LIST_POSITION = {
	CENTER: 'center'
};

export const OPTIONS_LIST_OFFSET = {
	top: 0,
	right: 0,
	bottom: 0,
	left: 0
};
